import styled from 'styled-components';
import { Row } from 'react-flexbox-grid';

export default styled(Row)`
  min-height: 100%;
`;



// WEBPACK FOOTER //
// ./src/views/common/layouts/Middle/styled-components.js